export const MediaSurveysActionTypes = {
  API_RESPONSE_SUCCESS: '@@media-survey/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@media-survey/API_RESPONSE_ERROR',

  GET_MEDIA_SURVEY: '@@media-survey/GET_MEDIA_SURVEY',
  LIST_MEDIA_SURVEYS: '@@media-survey/LIST_MEDIA_SURVEYS',
  ADD_MEDIA_SURVEY: '@@media-survey/ADD_MEDIA_SURVEY',
  UPDATE_MEDIA_SURVEY: '@@media-survey/UPDATE_MEDIA_SURVEY',
  DELETE_MEDIA_SURVEY: '@@media-survey/DELETE_MEDIA_SURVEY',

  RESET: '@@media-survey/RESET'
}
